import {MDIntent} from '@mintdata-wsp/common/components/MDIntent';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Dialog} from '@mintdata-wsp/wsp/ui/components/forms/Dialog';
import {DialogButton} from '@mintdata-wsp/wsp/ui/components/forms/DialogButton';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {ButtonStyle} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import {bind} from 'bind-decorator';
import * as React from 'react';

const styles = require('./DeleteDialog.less');

export type CloseHandler = () => void;
export type ClickDeleteHandler = () => void;

export interface IDeleteDialogProps
{
    title?:string;
    message:string | React.ReactElement<any>;
    actionText?:string;
    onClose?:CloseHandler;
    onClickDelete?:ClickDeleteHandler;
    isDisabled?:boolean;
}

export class DeleteDialog extends React.Component <IDeleteDialogProps, any>
{
    @bind
    private _onClose():void
    {
        const {
            onClose = () =>
            {
            }
        } = this.props;

        onClose();
    }

    @bind
    private _onClickDelete():void
    {
        const {
            onClickDelete = () =>
            {
            }
        } = this.props;

        onClickDelete();
    }

    public render():JSX.Element
    {
        const {
            title = 'Heads up!',
            message,
            actionText = 'DELETE',
            isDisabled
        } = this.props;

        return (
            <Dialog
                title={title}
                onClose={this._onClose}
            >
                <Column className={styles.base}>

                    <div className={styles.content}>
                        {message}
                    </div>

                    <Row className={styles.buttonsRow}>

                        <DialogButton
                            caption={'Cancel'}
                            intent={MDIntent.Default}
                            style={ButtonStyle.SimpleSecondary}
                            onClick={this._onClose}
                            className={styles.cancelBtn}
                        />

                        <DialogButton
                            caption={actionText}
                            onClick={this._onClickDelete}
                            intent={MDIntent.Danger}
                            isDisabled={isDisabled}
                        />

                    </Row>

                </Column>
            </Dialog>
        );
    }
}
